import { devtools } from "zustand/middleware";
import { createWithEqualityFn } from "zustand/traditional";

const useStore = createWithEqualityFn(
  devtools((set, get) => ({
    data: {
      formData: {
        users: [
          {
            firstName: "",
            lastName: "",
            email: "",
          },
        ],
      },
      formState: {
        usersData: {
          csvFileName: null,
          csvLength: 0,
          csvErrorRowsLength: 0,
          totalErrorCount: 0,
        },
      },
    },
    actions: {
      // =======================
      // STATE ACTIONS SETTERS
      // =======================
      handleSetAdminAddUsersFormValue: (data) => {
        set((s) => ({
          data: {
            ...s.data,
            formData: { ...s.data.formData, ...data },
          },
        }));
      },
      handleSetAdminAddUsersFormStates: (data) => {
        set((s) => ({
          data: {
            ...s.data,
            formState: { ...s.data.formState, ...data },
          },
        }));
      },
    },
  }))
);

export default useStore;
